import React, { Component } from 'react';
import Utils from 'libs/Utils';
import PropTypes from 'prop-types';

import './styles.css';

class FloatingBalloon extends Component {
  constructor(props) {
    super(props);

    this.hideTimeout = null;
    this.onClick = this.onClick.bind(this);
    this.hide = this.hide.bind(this);
    this.messageElm = null;

    this.state = {
      show: false,
    };
  }

  onClick() {
    if (this.state.show) {
      // Reset the animation
      this.messageElm.style.animation = 'none';
      // Use setTimeout to reset the animation in the next cycle
      setTimeout(() => { this.messageElm.style.animation = ''; }, 0);
    }

    this.messageElm.addEventListener(Utils.whichAnimationEvent(), this.hide);

    this.setState({
      show: true,
    });
  }

  hide() {
    this.messageElm.removeEventListener(Utils.whichAnimationEvent(), this.hide);

    this.setState({
      show: false,
    });
  }

  render() {
    let classNames = 'floating-balloon__message';
    if (this.state.show) classNames += ' floating-balloon__message--show';

    return (
      <span
        className="floating-balloon"
        onClick={this.onClick}
        onKeyUp={this.onClick}
        role="button"
        tabIndex="0"
      >
        {this.props.children}
        <span
          ref={(elm) => { this.messageElm = elm; }}
          className={classNames}
        >
          {this.props.text}
        </span>
      </span>
    );
  }
}

FloatingBalloon.propTypes = {
  children: PropTypes.element.isRequired,
  text: PropTypes.string.isRequired,
};

export default FloatingBalloon;



// WEBPACK FOOTER //
// ./src/components/FloatingBalloon/index.jsx